import React from 'react'

import '../styles/tradechart.css'
import Trad from '../../LiveTrading/templates/Trad'


const TradeChart = () => {
  return (
    <>
    <div className="tradechart">
      <Trad />
      </div>
    </>
  )
}

export default TradeChart